<template>
  <span class="link-tag" :class="customClass">
    <router-link v-if="to" :to="to"
      ><span @click="action"><slot></slot></span
    ></router-link>

    <a v-if="href && self" :href="href" @click="action"><slot></slot></a>

    <a v-if="href && !self" :href="href" target="_blank" rel="noopener" @click="action"
      ><slot></slot
    ></a>
  </span>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'Link',
  props: {
    to: { type: [String, Object] },
    href: { type: String },
    tc: { type: String },
    tcInfo: { type: Object },
    self: { type: Boolean },
    customClass: { type: Object },
  },
  methods: {
    ...mapActions(['triggerEvent']),
    action() {
      if (this.to) {
        this.triggerEvent({
          eventName: this.tc,
          addInfo: this.tcInfo
        });
        this.$router.push(this.to);
      }

      if (this.href) {
        this.triggerEvent({
          eventName: this.tc,
          addInfo: this.tcInfo
        });
      }
    },
  },
};
</script>
